import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';

type NavigationProps = {
  links: Array<{ onClick?: () => void; href?: string; label: string; isCurrent?: boolean }>;
};

export const Navigation: React.FC<NavigationProps> = ({ links = [] }) => {
  return (
    <Breadcrumb spacing={'15px'} separator={<Icon icon="chevron-right" boxSize={'12px'} />}>
      {links.map((link, i) =>
        i === 0 ? (
          <BreadcrumbItem
            key={link.label}
            style={{
              opacity: 0.5,
            }}>
            <Icon icon="arrow-left-long" style={{ marginRight: '15px' }} />
            <BreadcrumbLink onClick={link.onClick} href={link.href}>
              {link.label}
            </BreadcrumbLink>
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={link.label} isCurrentPage={link.isCurrent}>
            <BreadcrumbLink
              onClick={link.onClick}
              href={link.href}
              style={{
                fontFamily: link.isCurrent ? FontFamily.HELVETICA_NOW_BOLD : 'inherit',
                opacity: link.isCurrent ? 1 : 0.5,
              }}>
              {link.label}
            </BreadcrumbLink>
          </BreadcrumbItem>
        ),
      )}
    </Breadcrumb>
  );
};
